<div class="card" id="relatedKba_card">
    <div class="card-body" id="card-body-override">
        <div id="relatedKnowledgeBase_header" class="zsd-cust-common-pageheading-font active">
            {{"KnowledgeBase.ralatedArticle" | translate | uppercase }}
        </div>
        <div *ngIf="relatedKbArticles">
            <div class="relatedKnowledgeBase-title " *ngFor="let relatedkba of relatedKbArticles">
                <div class="relatedKnowledgeBase-title-icon"></div>
                <div ellipsis class="relatedKnowledgeBase-title-text breadcrumb-font" (click)="onClickTitle(relatedkba.relatedknowledgebaseId)">
                    {{relatedkba.relatedknowledgebaseTitle}}
                </div>
            </div>
        </div>
    </div>
</div>